// Create Promotion
export const CREATE_PROMOTION_REQUEST = 'CREATE_PROMOTION_REQUEST';
export const CREATE_PROMOTION_DONE = 'CREATE_PROMOTION_DONE';
export const CREATE_PROMOTION_FAILED = 'CREATE_PROMOTION_FAILED';
export const CREATE_PROMOTION_RESET = 'UPDATE_PROMOTION_RESET';